import { CreditProvisionEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import { FCSelector } from '../../model/form-config.interface';
import {
  CREDIT_PROVISION_2014_SUPPLEMENT,
  CREDIT_PROVISION_ALL_GUARANTEES,
  CREDIT_PROVISION_ARGENTINE_REPUBLIC,
  CREDIT_PROVISION_CERTAIN_RUSSIAN_ENTITIES,
  CREDIT_PROVISION_CERTAIN_VENEZUELAN_ENTITIES,
  CREDIT_PROVISION_CREDIT_EVENTS,
  CREDIT_PROVISION_CREDIT_EVENTS_GRACE_PERIOD,
  CREDIT_PROVISION_ESCROW,
  CREDIT_PROVISION_FALLBACK_SETTLEMENT_METHOD,
  CREDIT_PROVISION_FINANCIAL_REFERENCE_ENTITY_TERMS,
  CREDIT_PROVISION_HELLENIC_REPUBLIC,
  CREDIT_PROVISION_LPN,
  CREDIT_PROVISION_MONOLINE_INSURER,
  CREDIT_PROVISION_NOTICE_OF_PUBLIC_INFO,
  CREDIT_PROVISION_NTCE_SUPPLEMENT,
  CREDIT_PROVISION_PHYSICAL_SETTLEMENT_MATRIX,
  CREDIT_PROVISION_REPUBLIC_OF_HUNGARY,
  CREDIT_PROVISION_RUSSIAN_FEDERATION,
  CREDIT_PROVISION_SENIOR_NON_PREFERRED_REF_OBLIGATIONS,
  CREDIT_PROVISION_SETTLEMENT_METHOD,
  CREDIT_PROVISION_SUBORDINATED_EUOPEAN_INSURANCE_TERMS,
  CREDIT_PROVISION_SUKUK_CORPORATE,
  SOVEREIGN_NO_ASSET_PACKAGE_DELIVERY_SUPPLEMENT,
  US_MUNICIPAL_REFERENCE_ENTITY_SUPPLEMENT,
} from './product-capture-field-selectors.consts';

export const PHYSICAL_SETTLEMENT_MATRIX: FCSelector = {
  formControlNames: [CREDIT_PROVISION_PHYSICAL_SETTLEMENT_MATRIX],
  options: [
    {
      id: true,
      effects: [
        {
          formControlNames: [
            CREDIT_PROVISION_CREDIT_EVENTS,
            CREDIT_PROVISION_FALLBACK_SETTLEMENT_METHOD,
            CREDIT_PROVISION_ALL_GUARANTEES,
            CREDIT_PROVISION_ESCROW,
            CREDIT_PROVISION_NOTICE_OF_PUBLIC_INFO,

            CREDIT_PROVISION_NTCE_SUPPLEMENT,
            CREDIT_PROVISION_MONOLINE_INSURER,
            CREDIT_PROVISION_2014_SUPPLEMENT,
            US_MUNICIPAL_REFERENCE_ENTITY_SUPPLEMENT,
            SOVEREIGN_NO_ASSET_PACKAGE_DELIVERY_SUPPLEMENT,

            CREDIT_PROVISION_ARGENTINE_REPUBLIC,
            CREDIT_PROVISION_CERTAIN_RUSSIAN_ENTITIES,
            CREDIT_PROVISION_CERTAIN_VENEZUELAN_ENTITIES,
            CREDIT_PROVISION_FINANCIAL_REFERENCE_ENTITY_TERMS,
            CREDIT_PROVISION_HELLENIC_REPUBLIC,
            CREDIT_PROVISION_LPN,
            CREDIT_PROVISION_REPUBLIC_OF_HUNGARY,
            CREDIT_PROVISION_RUSSIAN_FEDERATION,
            CREDIT_PROVISION_SENIOR_NON_PREFERRED_REF_OBLIGATIONS,
            CREDIT_PROVISION_SUBORDINATED_EUOPEAN_INSURANCE_TERMS,
            CREDIT_PROVISION_SUKUK_CORPORATE,
            CREDIT_PROVISION_CREDIT_EVENTS_GRACE_PERIOD,
          ],
          readOnly: true,
        },
        {
          formControlNames: [
            CREDIT_PROVISION_ALL_GUARANTEES,
            CREDIT_PROVISION_ESCROW,
            CREDIT_PROVISION_NOTICE_OF_PUBLIC_INFO,
            CREDIT_PROVISION_FALLBACK_SETTLEMENT_METHOD,
            CREDIT_PROVISION_CREDIT_EVENTS,
          ],
          readOnly: true,
          hidden: false,
        },
        {
          formControlNames: [CREDIT_PROVISION_SETTLEMENT_METHOD],
          readOnly: false,
          hidden: false,
        },
      ],
    },
    {
      id: false,
      effects: [
        {
          formControlNames: [
            CREDIT_PROVISION_CREDIT_EVENTS,
            CREDIT_PROVISION_SETTLEMENT_METHOD,
            CREDIT_PROVISION_FALLBACK_SETTLEMENT_METHOD,
            CREDIT_PROVISION_ALL_GUARANTEES,
            CREDIT_PROVISION_ESCROW,
            CREDIT_PROVISION_NOTICE_OF_PUBLIC_INFO,

            CREDIT_PROVISION_NTCE_SUPPLEMENT,
            CREDIT_PROVISION_MONOLINE_INSURER,
            CREDIT_PROVISION_2014_SUPPLEMENT,
            US_MUNICIPAL_REFERENCE_ENTITY_SUPPLEMENT,
            SOVEREIGN_NO_ASSET_PACKAGE_DELIVERY_SUPPLEMENT,

            CREDIT_PROVISION_ARGENTINE_REPUBLIC,
            CREDIT_PROVISION_CERTAIN_RUSSIAN_ENTITIES,
            CREDIT_PROVISION_CERTAIN_VENEZUELAN_ENTITIES,
            CREDIT_PROVISION_FINANCIAL_REFERENCE_ENTITY_TERMS,
            CREDIT_PROVISION_HELLENIC_REPUBLIC,
            CREDIT_PROVISION_LPN,
            CREDIT_PROVISION_REPUBLIC_OF_HUNGARY,
            CREDIT_PROVISION_RUSSIAN_FEDERATION,
            CREDIT_PROVISION_SENIOR_NON_PREFERRED_REF_OBLIGATIONS,
            CREDIT_PROVISION_SUBORDINATED_EUOPEAN_INSURANCE_TERMS,
            CREDIT_PROVISION_SUKUK_CORPORATE,
          ],
          readOnly: false,
        },
      ],
    },
    {
      id: null,
      effects: [
        {
          formControlNames: [
            CREDIT_PROVISION_CREDIT_EVENTS,
            CREDIT_PROVISION_SETTLEMENT_METHOD,
            CREDIT_PROVISION_FALLBACK_SETTLEMENT_METHOD,
            CREDIT_PROVISION_ALL_GUARANTEES,
            CREDIT_PROVISION_ESCROW,
            CREDIT_PROVISION_NOTICE_OF_PUBLIC_INFO,

            CREDIT_PROVISION_NTCE_SUPPLEMENT,
            CREDIT_PROVISION_MONOLINE_INSURER,
            CREDIT_PROVISION_2014_SUPPLEMENT,
            US_MUNICIPAL_REFERENCE_ENTITY_SUPPLEMENT,
            SOVEREIGN_NO_ASSET_PACKAGE_DELIVERY_SUPPLEMENT,

            CREDIT_PROVISION_ARGENTINE_REPUBLIC,
            CREDIT_PROVISION_CERTAIN_RUSSIAN_ENTITIES,
            CREDIT_PROVISION_CERTAIN_VENEZUELAN_ENTITIES,
            CREDIT_PROVISION_FINANCIAL_REFERENCE_ENTITY_TERMS,
            CREDIT_PROVISION_HELLENIC_REPUBLIC,
            CREDIT_PROVISION_LPN,
            CREDIT_PROVISION_REPUBLIC_OF_HUNGARY,
            CREDIT_PROVISION_RUSSIAN_FEDERATION,
            CREDIT_PROVISION_SENIOR_NON_PREFERRED_REF_OBLIGATIONS,
            CREDIT_PROVISION_SUBORDINATED_EUOPEAN_INSURANCE_TERMS,
            CREDIT_PROVISION_SUKUK_CORPORATE,
          ],
          readOnly: true,
        },
      ],
    },
  ],
};

export interface PhysicalSettlementMatrix {
  id: string;
  transactionType: string;
  obligationCategory: string;
  obligationCharacteristics: string[];
  valuationObligationCategory: string;
  valuationObligationCharacteristics: string[];
  allGuarantees: boolean;
  escrow: boolean;
  noticeOfPubliclyAvailableInformation: boolean;
  creditEvents: string[];
  settlementMethod: string;
  fallbackSettlementMethod: string;
  supplementTo2014ISDACDD: boolean;
  financialReferenceEntityTerms: boolean;
  subordinatedEuropeanInsuranceTerms: boolean;
  provisionsMonolineInsurer: boolean;
  provisionsForRussianFederation: boolean;
  addnProvisionsCertainRussianEntities: boolean;
  provisionsForRepublicOfHungary: boolean;
  addnProvisionsCertainVenezuelanEntities: boolean;
  provisionsForArgentineRepublic: boolean;
  provisionsForLPN: boolean;
  provisionsForSukukCorporate: boolean;
  addnProvisionsHellenicRepublic: boolean;
  ntceSupplement: boolean;
  suppUSMunicipals: boolean;
  seniorNonPreferredRefObligations: boolean;
  supp2014SovereignNoAssetPkgDelivery: boolean;
}

export const PHYSICAL_SETTLEMENT_SENSITIVE_FIELDS: string[] = [
  CreditProvisionEnum.noticeOfPubliclyAvailableInformation,
  CreditProvisionEnum.escrow,
  CreditProvisionEnum.allGuarantees,
];
